var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.ajaxData,"max-height":"700","show-summary":_vm.showSummary,"sum-text":"总计"}})}
var staticRenderFns = []

export { render, staticRenderFns }